import config from '../config'

/**
 * service for getting data of components like product and artist
 */
export default class DataService {
  /**
     * @typedef {Object} ArtistidDiscography
     * @property {Articlesartistid} discography
     * @property {Artistid} artistid
     *
     */

  /**
     * @typedef {Object} Articlesartistid
     * @property {Artistid[]} artistid
     * @property {Article} article
     */

  /**
     * @typedef {Object} Artistid
     * @property {string} artistid
     * @property {string} artistartikel
     * @property {string} artisttrack
     * @property {string} artistnatuerlich
     * @property {string} disambiguierung
     * @property {string} orchesterkz
     * @property {Artistid|null} mainArtistid
     * @property {Artistid|null} variantofArtistid
     * @property {Artistid|null} partofArtistid
     * @property {Artistid|null} aliasofArtistid
     */

  /**
     * @TODO there are more properties here
     * @typedef {Object} Article
     * @property {Artwork[]} artworks
     * @property {string} title
     *
     * @property {boolean} has_sound
     * @property {boolean} has_cover
     * @property {boolean} has_tracks
     */

  /**
     * @typedef {Artwork} Artwork
     * @property {string} url
     * @property {number} resolution_y
     * @property {number} resolution_x
     */

  /**
     * @param {String} artistid
     * @return {Promise}
     */
  static getArtistByArtistId (artistid) {
    const url = config['api-baseurl'] + '/api/artist/' + artistid + '/discography'
    // const url = "/api/artist/by-artist-id/" + artistid + "/discography";
    return new Promise((resolve, reject) => {
      $.get({ url: url, dataType: 'json' })
        .done((data) => {
          resolve(data)
        })
        .fail((jqXHR, textStatus, errorThrown) => {
          reject(jqXHR, textStatus, errorThrown)
        })
    })
  }

  /**
     * @param {String} ean
     * @param {String} distributorCode
     * @return {Promise}
     */
  static getProduct (ean, distributorCode = null) {
    const url = config['api-baseurl'] + '/api/product/' + ean + ((distributorCode != null) ? '/' + distributorCode : '')
    return new Promise((resolve, reject) => {
      $.get(url)
        .done((data) => {
          resolve(data)
        })
        .fail((jqXHR, textStatus, errorThrown) => {
          reject(jqXHR, textStatus, errorThrown)
        })
    })
  }
}
